import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import logosmall from '../../../assets/img/logosmall.svg'
import letterlogoblack from '../../../assets/img/letterlogoblack.svg'
import letterlogowhite from '../../../assets/img/letterlogowhite.svg'
import Globe from '../../lang'
import styles from './index.module.less'
import useLang from '../../../utils/lang.ts'


function Header(props) {
  const [lang] = useLang()
  const history = useHistory();
  const { intl, style, enScroll } = props
  function toHome () {
    const { href } = window.location
    if (href === 'https://privacy.mi.com/trust#/security/vulnerability-management?locale=en') {
      window.location.href = 'https://trust.mi.com'
    } else if (href === 'https://preview.privacy.mi.com/trust#/security/vulnerability-management?locale=en') {
      window.location.href = 'http://trust-center-cl45206.staging.ingress.mice.cc.d.xiaomi.net'
    } else {
      history.push('/home?locale=zh')
    }
  }
  return (
    <div className={styles.header} style={style}>
      <div className={styles.leftContent}>
        <img src={logosmall} className={styles.logo} />
        <img src={enScroll ? letterlogoblack : letterlogowhite} className={styles.letterlogo} />
        <span style={{ color: enScroll ? '#000' : '#fff' }}>|</span>
        <span className={enScroll ? styles.enScrollTitle : styles.title}>{intl.formatMessage({ id: 'Trust.Center' })}</span>
      </div>
      <div className={enScroll ? styles.enScrollRightContent : styles.rightContent} style={lang === 'zh' ? {} : { width: '400px' }}>
        <Link onClick={toHome}>{intl.formatMessage({ id: 'Home' })}</Link>
        <Link to={`/security/vulnerability-management?locale=${lang}`}>{intl.formatMessage({ id: 'Secure.Center' })}</Link>
        <a href="https://privacy.mi.com/all/" target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: 'Privacy.Policy' })}</a>
      </div>
      <Globe enScroll={enScroll} />
    </div>
  )
}

export default injectIntl(Header)
